import type { AnalysisState } from '@aibi/contracts';
import { stableHash } from '@aibi/shared';
import { canonicalJson } from '../context/canonical-json.js';

/** Huella estable de un Analysis State: detecta cambios entre proponer y aplicar. */
export const analysisStateFingerprint = (state: AnalysisState): string =>
  stableHash(canonicalJson(state), 10);
